import { render, staticRenderFns } from "./Alipy.vue?vue&type=template&id=a8c3d916&scoped=true&"
import script from "./Alipy.vue?vue&type=script&lang=js&"
export * from "./Alipy.vue?vue&type=script&lang=js&"
import style0 from "./Alipy.vue?vue&type=style&index=0&id=a8c3d916&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c3d916",
  null
  
)

export default component.exports